import { ElementType } from "react";
import HomeIcon from "../assets/icons/HomeIcon";
import SettingsSidebarIcon from "../assets/icons/SettingsSidebarIcon";
import BusinessesIcon from "../assets/icons/sidebar/BusinessesIcon";
import EmployeeIcon from "../assets/icons/sidebar/EmployeeIcon";
import OrgSettingIcon from "../assets/icons/sidebar/OrgSettingIcon";
import ProductsIcon from "../assets/icons/sidebar/ProductsIcon";
import UsersRollIcon from "../assets/icons/sidebar/UsersRollIcon";
import WalletIcon from "../assets/icons/WalletIcon";
import { Role } from "../types/common";

interface MenuType {
  name: string;
  path: string;
  icon?: ElementType;
  badge?: string;
  role: Role[];
}

interface MenuTypes extends MenuType {
  children?: MenuType[];
}

const AllSidebarMenu: MenuTypes[] = [
  {
    name: "Sheba Portal",
    path: "/admin/dashboard",
    icon: HomeIcon,
    role: [],
  },
  {
    name: "Businesses",
    path: "/admin/businesses",
    icon: BusinessesIcon,
    role: ["SUPER_ADMIN"],
    children: [
      {
        name: "Business List",
        path: "/admin/businesses/business-list",
        role: ["SUPER_ADMIN"],
      },
      {
        name: "Holiday Calender",
        path: "/admin/businesses/holiday-calender",
        role: ["SUPER_ADMIN"],
      },
      // {
      //   name: "Requests",
      //   path: "/admin/businesses/requests",
      //   role: ["SUPER_ADMIN"],
      // },
    ],
  },
  // {
  //   name: "Customers",
  //   path: "/admin/customers",
  //   icon: CustomersIcon,
  //   role: ["Admin"],
  // },
  // {
  //   name: "Payment",
  //   path: "/admin/payment",
  //   icon: PaymentIcon,
  //   role: ["Admin"],
  // },
  // {
  //   name: "Packages",
  //   path: "/admin/packages",
  //   icon: PackagesIcon,
  //   role: ["Admin"],
  // }

  {
    name: "Products",
    path: "/admin/products",
    icon: ProductsIcon,
    role: ["SUPER_ADMIN"],
    children: [
      // {
      //   name: "Product",
      //   path: "/admin/products/product",
      //   role: [],
      // },
      {
        name: "Product List",
        path: "/admin/products/product-list",
        role: ["SUPER_ADMIN"],
      },
      // {
      //   name: "Product Categories",
      //   path: "/admin/products/product-categories",
      //   role: ["SUPER_ADMIN"],
      // },
    ],
  },

  {
    name: "Sheba Pay Wallet",
    path: "/admin/sheba-pay-wallet",
    icon: WalletIcon,
    role: ["Admin", "checker", "maker", "approver"],
  },
  // {
  //   name: "Feedback",
  //   path: "/admin/feedback",
  //   icon: FeedbackIcon,
  //   role: ["Admin"],
  // },
  // {
  //   name: "Header",
  //   path: "/admin/header",
  //   icon: HeaderIcon,
  //   role: ["Admin"],
  // },
  // {
  //   name: "Footer",
  //   path: "/admin/footer",
  //   icon: HeaderIcon,
  //   role: ["Admin"],
  // },
  // {
  //   name: "Home",
  //   path: "/admin/home",
  //   icon: HomeIcon,
  //   role: ["Admin"],
  // },
  // {
  //   name: "Stories",
  //   path: "/admin/stories",
  //   icon: StoriesIcon,
  //   role: ["Admin"],
  // },
  // {
  //   name: "Privacy Policy",
  //   path: "/admin/privacy-policy",
  //   icon: HomeIcon,
  //   role: ["Admin"],
  // },
  // {
  //   name: "Pricing & FAQ",
  //   path: "/admin/pricing-faq",
  //   icon: FaqIcon,
  //   role: ["Admin"],
  // },
  {
    name: "Disbursement",
    path: "/admin/salary-disbursement",
    icon: WalletIcon,
    role: ["Admin", "checker", "maker", "approver", "user"],
    children: [
      {
        name: "Batch",
        path: "/admin/salary-disbursement/batch",
        role: ["Admin", "checker", "maker", "approver", "user"],
      },
      {
        name: "Statements",
        path: "/admin/salary-disbursement/statements",
        role: ["Admin", "checker", "maker", "approver", "user"],
      },
      // {
      //   name: "Payments",
      //   path: "/admin/salary-disbursement/payments",
      //   role: ["Admin"],
      // },
      // {
      //   name: "History",
      //   path: "/admin/salary-disbursement/history",
      //   role: [],
      // },
    ],
  },

  // {
  //   name: "Vendor Payment",
  //   path: "/admin/vendor-payment",
  //   icon: WalletIcon,
  //   role: ["Admin", "checker", "maker", "approver"],
  //   children: [
  //     {
  //       name: "Batch",
  //       path: "/admin/vendor-payment/batch",
  //       role: ["Admin", "checker", "maker", "approver"],
  //     },
  //     // {
  //     //   name: "Payments",
  //     //   path: "/admin/salary-disbursement/payments",
  //     //   role: ["Admin"],
  //     // },
  //     // {
  //     //   name: "History",
  //     //   path: "/admin/salary-disbursement/history",
  //     //   role: [],
  //     // },
  //   ],
  // },

  {
    name: "Users Role Access",
    path: "/admin/users-roll-access",
    icon: UsersRollIcon,
    role: ["Admin", "SUPER_ADMIN"],
    children: [
      {
        name: "User List",
        path: "/admin/users-roll-access/user-list",
        role: ["Admin", "SUPER_ADMIN"],
      },
      {
        name: "Role Access",
        path: "/admin/users-roll-access/roll-access",
        role: ["Admin", "SUPER_ADMIN"],
      },
      {
        name: "Approval Dynamic",
        path: "/admin/users-roll-access/approval-dynamic-list",
        role: ["Admin", "SUPER_ADMIN"],
      },

      // {
      //   name: "User Group",
      //   path: "/admin/users-roll-access/user-group",
      //   role: ["Admin", "SUPER_ADMIN"],
      // },
      // {
      //   name: "Create Role",
      //   path: "/admin/users-roll-access/create-role",
      //   role: ["Admin"],
      // },
    ],
  },
  {
    name: "User Access Permission",
    path: "/admin/user-access-permission",
    icon: UsersRollIcon,
    role: ["Admin", "SUPER_ADMIN"],
    children: [
      {
        name: "User List",
        path: "/admin/user-access-permission/user-list",
        role: ["Admin", "SUPER_ADMIN"],
      },
      {
        name: "User Group",
        path: "/admin/user-access-permission/user-group",
        role: ["Admin", "SUPER_ADMIN"],
      },
    ],
  },

  {
    name: "Approval Matrix",
    path: "/admin/approval-matrix",
    icon: UsersRollIcon,
    role: ["Admin"],
    children: [
      {
        name: "Vendor Management",
        path: "/admin/approval-matrix/vendor-management",
        role: ["Admin"],
      },
    ],
  },
  {
    name: "Settings",
    path: "/admin/settings",
    icon: SettingsSidebarIcon,
    role: ["Admin"],
  },
  {
    name: "Organization",
    path: "/admin/org-settings",
    icon: OrgSettingIcon,
    role: ["Admin", "HR_ADMIN"],
    children: [
      {
        name: "Business Units",
        path: "/admin/org-settings/business-units",
        role: ["Admin", "HR_ADMIN"],
      },
      {
        name: "Work Stations",
        path: "/admin/org-settings/work-stations",
        role: ["Admin", "HR_ADMIN"],
      },
      {
        name: "Departments",
        path: "/admin/org-settings/departments",
        role: ["Admin", "HR_ADMIN"],
      },
      {
        name: "Designations",
        path: "/admin/org-settings/designations",
        role: ["Admin", "HR_ADMIN"],
      },
    ],
  },

  {
    name: "Employees",
    path: "/admin/employees",
    icon: EmployeeIcon,
    role: ["Admin", "HR_ADMIN", "SUPER_ADMIN"],
  },

  // {
  //   name: "Payment Dashboard",
  //   path: "/admin/bsrm",
  //   icon: OverviewIcon,
  //   role: ["BSRM_USER"],
  //   children: [
  //     {
  //       name: "Dashboard",
  //       path: "/admin/bsrm/dashboard",
  //       role: ["BSRM_USER"],
  //     },
  //     {
  //       name: "Statement",
  //       path: "/admin/bsrm/statement",
  //       role: ["BSRM_USER"],
  //     },
  //     {
  //       name: "Dealer List",
  //       path: "/admin/bsrm/dealer-list",
  //       role: ["BSRM_USER"],
  //     },
  //     {
  //       name: "Trader List",
  //       path: "/admin/bsrm/trader-list",
  //       role: ["BSRM_USER"],
  //     },
  //     // {
  //     //   name: "Reconcile",
  //     //   path: "/admin/bsrm-dashboard",
  //     //   role: ["SUPER_ADMIN"],
  //     // },
  //   ],
  // },
];

export default AllSidebarMenu;
